var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.showVisible,
        "append-to-body": "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showVisible = $event
        },
        close: _vm.closeEdit,
        open: _vm.openEdit,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticStyle: { "margin-left": "30px", "margin-right": "10px" },
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-position": "left",
            "label-width": "100px",
          },
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("活动信息")]),
          _c(
            "el-form-item",
            { attrs: { label: "活动类型", prop: "type" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: {
                    disabled:
                      _vm.form.id &&
                      !(_vm.form.status === 0 || _vm.form.status === 1),
                  },
                  on: { change: _vm.radioChange },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content:
                          "通用性活动，获取活动链接的平台用户可参与，活动页面样式通过配置实现",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全体用户可参与"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content:
                          "通用性乘车活动，活动期间完成乘车订单的用户可参与，活动页面样式通过配置实现",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("乘车用户可参与"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content:
                          "通用性乘车活动，活动期间完成在平台内的首笔乘车订单的用户可参与，活动页面样式通过配置实现",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("首单乘车用户可活动"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content:
                          "特定主题活动，用户参与条件以及活动页面样式需单次设计及开发",
                        placement: "top-start",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 4 } }, [
                        _vm._v("特殊主题活动"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.type !== 4,
                  expression: "form.type !== 4",
                },
              ],
              attrs: { label: "次数", required: "" },
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-align-center" },
                [
                  _vm.form.type === 1
                    ? [
                        _c("div", { staticClass: "margin-right-10" }, [
                          _vm._v("每人可参与: "),
                        ]),
                        _c("el-input-number", {
                          staticClass: "margin-right-10",
                          attrs: {
                            min: 0,
                            controls: false,
                            disabled:
                              _vm.form.id &&
                              (_vm.form.status === 2 || _vm.form.status === -1),
                          },
                          model: {
                            value: _vm.form.allowedCountPerUser,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "allowedCountPerUser", $$v)
                            },
                            expression: "form.allowedCountPerUser",
                          },
                        }),
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "默认状态：活动期间",
                              disabled:
                                _vm.form.id &&
                                (_vm.form.status === 2 ||
                                  _vm.form.status === -1),
                            },
                            model: {
                              value: _vm.form.allowedPeriod,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "allowedPeriod", $$v)
                              },
                              expression: "form.allowedPeriod",
                            },
                          },
                          _vm._l(_vm.dateOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.form.type === 2
                    ? [
                        _c("div", { staticClass: "margin-right-10" }, [
                          _vm._v("每完成"),
                        ]),
                        _c("el-input-number", {
                          staticClass: "margin-right-10",
                          attrs: {
                            min: 0,
                            controls: false,
                            disabled:
                              _vm.form.id &&
                              (_vm.form.status === 2 || _vm.form.status === -1),
                          },
                          model: {
                            value: _vm.form.ordersPerCompleted,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "ordersPerCompleted", $$v)
                            },
                            expression: "form.ordersPerCompleted",
                          },
                        }),
                        _vm._v("单，\n          "),
                        _c("div", { staticClass: "margin-right-10" }, [
                          _vm._v("可参与"),
                        ]),
                        _c("el-input-number", {
                          staticClass: "margin-right-10",
                          attrs: {
                            min: 0,
                            controls: false,
                            disabled:
                              _vm.form.id &&
                              (_vm.form.status === 2 || _vm.form.status === -1),
                          },
                          model: {
                            value: _vm.form.allowedCount,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "allowedCount", $$v)
                            },
                            expression: "form.allowedCount",
                          },
                        }),
                        _vm._v("次\n        "),
                      ]
                    : _vm._e(),
                  _vm.form.type === 3
                    ? [
                        _c("div", { staticClass: "margin-right-10" }, [
                          _vm._v("完成首单乘车订单，可参与"),
                        ]),
                        _c("el-input-number", {
                          staticClass: "margin-right-10",
                          attrs: {
                            min: 0,
                            controls: false,
                            disabled:
                              _vm.form.id &&
                              (_vm.form.status === 2 || _vm.form.status === -1),
                          },
                          model: {
                            value: _vm.form.firstOrderAllowedCount,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "firstOrderAllowedCount", $$v)
                            },
                            expression: "form.firstOrderAllowedCount",
                          },
                        }),
                        _vm._v("次\n        "),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "限制参与用户", prop: "user" } },
            [
              _vm.restrictedPhoneList.length === 0
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        icon: "el-icon-plus",
                        plain: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showDisabled("user")
                        },
                      },
                    },
                    [_vm._v("新增用户")]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "border-line",
                      staticStyle: { width: "490px" },
                    },
                    [
                      _vm._l(_vm.restrictedPhoneList, function (tag, index) {
                        return _c(
                          "el-tag",
                          {
                            key: tag.phone,
                            staticClass: "margin-right-8 margin-bottom-8",
                            attrs: {
                              closable: "",
                              type: "info",
                              "disable-transitions": false,
                            },
                            on: {
                              close: function ($event) {
                                return _vm.delValue(index, "user")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(tag.phone) + "\n        "
                            ),
                          ]
                        )
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "margin-bottom-8",
                          attrs: {
                            type: "success",
                            icon: "el-icon-plus",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showDisabled("user")
                            },
                          },
                        },
                        [_vm._v("新增用户")]
                      ),
                    ],
                    2
                  ),
            ],
            1
          ),
          _vm.form.type !== 1
            ? _c(
                "el-form-item",
                { attrs: { label: "有效线路", prop: "line" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.lineChange },
                              model: {
                                value: _vm.form.allowedLine,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "allowedLine", $$v)
                                },
                                expression: "form.allowedLine",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("全部线路"),
                              ]),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "margin-top-8",
                                  attrs: { label: 1 },
                                },
                                [_vm._v("部分线路")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "margin-top-15 margin-left-15",
                          attrs: { span: 12 },
                        },
                        [
                          _vm.allowedLineIds.length === 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    icon: "el-icon-plus",
                                    plain: "",
                                    disabled: !_vm.form.allowedLine,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDisabled("line")
                                    },
                                  },
                                },
                                [_vm._v("新增线路")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "border-line",
                                  staticStyle: { width: "375px" },
                                },
                                [
                                  _vm._l(
                                    _vm.allowedLineIds,
                                    function (tag, index) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: tag.lineName,
                                          staticClass:
                                            "margin-right-8 margin-bottom-8",
                                          attrs: {
                                            closable: "",
                                            type: "info",
                                            "disable-transitions": false,
                                          },
                                          on: {
                                            close: function ($event) {
                                              return _vm.delValue(index, "line")
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(tag.lineName) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "margin-bottom-8",
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-plus",
                                        plain: "",
                                        disabled: !_vm.form.allowedLine,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDisabled("line")
                                        },
                                      },
                                    },
                                    [_vm._v("新增路线")]
                                  ),
                                ],
                                2
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "活动名称", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "请输入活动名称",
                  maxlength: "10",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "is-required", attrs: { label: "活动时间" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "请选择开始时间",
                  "picker-options": _vm.pickerOptionStart(),
                  disabled:
                    _vm.form.id &&
                    (_vm.form.status === 2 || _vm.form.status === -1),
                },
                on: {
                  change: function ($event) {
                    return _vm.checkTime($event, "start")
                  },
                },
                model: {
                  value: _vm.form.startTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startTime", $$v)
                  },
                  expression: "form.startTime",
                },
              }),
              _c("span", [_vm._v(" - ")]),
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "请选择结束时间",
                  "picker-options": _vm.pickerOptionEnd(),
                },
                on: {
                  change: function ($event) {
                    return _vm.checkTime($event, "end")
                  },
                },
                model: {
                  value: _vm.form.endTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endTime", $$v)
                  },
                  expression: "form.endTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动规则", required: "", prop: "description" } },
            [
              _c("rich-text-editor", {
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _vm.form.type !== 4
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("div", { staticClass: "title-box" }, [
                        _vm._v("页面展示"),
                      ]),
                    ]
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "页面头图",
                            required: "",
                            prop: "images",
                          },
                        },
                        [
                          _c("uploadImage", {
                            attrs: {
                              imageList: _vm.form.images,
                              code: "activity",
                              isShowTip: true,
                              fileType: ["jpg", "png"],
                              fileSize: 1,
                              WHtip: true,
                              limit: 1,
                              width: 750,
                              height: 588,
                              accept: ".jpg,.png",
                              multiple: false,
                            },
                            on: { input: _vm.getHeaderImg },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "页面背景色",
                            required: "",
                            prop: "backgroundColor",
                          },
                        },
                        [
                          _c("el-color-picker", {
                            model: {
                              value: _vm.form.backgroundColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "backgroundColor", $$v)
                              },
                              expression: "form.backgroundColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
              },
            },
            [_c("div", { staticClass: "title-box" }, [_vm._v("分享信息")])]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "标题", prop: "shareTitle", required: "" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "请输入标题",
                  maxlength: "20",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.shareTitle,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "shareTitle",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.shareTitle",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "分享图", prop: "shareImages", required: "" } },
            [
              _c("uploadImage", {
                attrs: {
                  imageList: _vm.form.shareImages,
                  code: "activity",
                  isShowTip: true,
                  WHtip: true,
                  fileSize: 1,
                  limit: 1,
                  width: 600,
                  height: 480,
                  fileType: ["jpg", "png"],
                  accept: ".jpg,.png",
                  multiple: false,
                },
                on: { input: _vm.getShareImg },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _c("select-user", {
        ref: "selectUser",
        attrs: { visible: _vm.userVisible },
        on: { userSubmit: _vm.selectSubmit },
      }),
      _c("select-line", {
        ref: "selectLine",
        attrs: { visible: _vm.lineVisible },
        on: { lineSubmit: _vm.selectSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }